import * as React from 'react';
import { Breadcrumbs } from "../Breadcrumbs";
import { Item } from "./components/Item";
import * as main from "./style.module.scss";
import data from "./seriesList.json";
export const MainPage = () => {
  return (
    <>
      <section className={main.screen1}>
        <div className="container">
          <Breadcrumbs mainPage={true}/>
          <div className="row">
            <div className={"col-12 col-lg-8"}>
              <h1>Субтитры к сериалам на английском языке</h1>
            </div>
          </div>
        </div>
      </section>
      <section className={main.main}>
        <div className="container">
          {data.map((elem, index) => (
            <div className="row" key={index}>
              <h2 className="col-12">{elem.letter}</h2>
              <Item letter={elem.series}/>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};
